<template>
  <v-dialog v-model="dialog" scrollable width="600">
    <v-card>
      <v-toolbar color="primary" dense class="elevation-0" dark>
        <v-toolbar-title>Cập nhật thực đơn ngày {{ date | ddmmyyyy }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form">
          <!-- menu 1 -->
          <div v-if="menu === 'menu1'">
            <div class="font-weight-bold mt-4">
              1. Thực đơn 1
            </div>
            <v-row class="mt-4">
              <v-col cols="11" class="py-0">
                <AutocompleteDish
                  v-model="menu1MainDish1"
                  clear-icon="mdi-close"
                  label="Món chính 1"
                  outlined
                  dense
                  required
                  class="required"
                  :rules="[$rules.required]"
                  :filters="mainDishFilter"
                />
              </v-col>
              <v-col cols="1"> </v-col>
              <!-- <v-col cols="11" class="py-0">
              <AutocompleteDish
                v-model="menu1MainDish2"
                clear-icon="mdi-close"
                label="Món chính 2"
                outlined
                dense
                required
                class="required"
                :rules="[$rules.required]"
                :filters="mainDishFilter"
              />
            </v-col>
            <v-col cols="1"> </v-col> -->
            </v-row>
            <v-row v-for="index in menu1SideDishNumArray" :key="`menu1-${index}`">
              <v-col cols="11">
                <AutocompleteDish
                  v-model="menu1SideDishes[index]"
                  clear-icon="mdi-close"
                  label="Món phụ"
                  outlined
                  dense
                  required
                  class="required"
                  :rules="[$rules.required]"
                  :filters="sideDishFilter"
                />
              </v-col>
              <v-col cols="1">
                <v-btn v-if="index === 0" disabled icon></v-btn>
                <v-btn v-if="index > 0" style="margin-top: 2px" color="cancel" @click="removeSideDishMenu1(index)" icon
                  ><v-icon>mdi-close</v-icon></v-btn
                >
              </v-col>
            </v-row>
            <v-btn
              color="primary"
              class="text-none mb-4"
              style="letter-spacing: 0.2px !important"
              @click="addSideDishMenu1()"
              text
              ><v-icon class="mr-2 ml-n4">mdi-plus</v-icon>Thêm món phụ
            </v-btn>
          </div>

          <!-- menu 2 -->
          <div v-else-if="menu === 'menu2'">
            <div class="font-weight-bold mt-4">
              2. Thực đơn 2
            </div>
            <v-row class="mt-4">
              <v-col cols="11" class="py-0">
                <AutocompleteDish
                  v-model="menu2MainDish1"
                  clear-icon="mdi-close"
                  label="Món chính 1"
                  outlined
                  dense
                  required
                  class="required"
                  :rules="[$rules.required]"
                  :filters="mainDishFilter"
                />
              </v-col>
              <v-col cols="1"> </v-col>
              <!-- <v-col cols="11" class="py-0">
              <AutocompleteDish
                v-model="menu2MainDish2"
                clear-icon="mdi-close"
                label="Món chính 2"
                outlined
                dense
                required
                class="required"
                :rules="[$rules.required]"
                :filters="mainDishFilter"
              />
            </v-col>
            <v-col cols="1"> </v-col> -->
            </v-row>
            <v-row v-for="index in menu2SideDishNumArray" :key="`menu2-${index}`">
              <v-col cols="11">
                <AutocompleteDish
                  v-model="menu2SideDishes[index]"
                  clear-icon="mdi-close"
                  label="Món phụ"
                  outlined
                  dense
                  required
                  class="required"
                  :rules="[$rules.required]"
                  :filters="sideDishFilter"
                />
              </v-col>
              <v-col cols="1">
                <v-btn v-if="index === 0" disabled icon></v-btn>
                <v-btn v-if="index > 0" style="margin-top: 2px" color="cancel" @click="removeSideDishMenu2(index)" icon
                  ><v-icon>mdi-close</v-icon></v-btn
                >
              </v-col>
            </v-row>
            <v-btn
              color="primary"
              class="text-none mb-4"
              style="letter-spacing: 0.2px !important"
              @click="addSideDishMenu2()"
              text
              ><v-icon class="mr-2 ml-n4">mdi-plus</v-icon>Thêm món phụ
            </v-btn>
          </div>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <v-btn outlined @click="cancel">HUỶ</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="save">LƯU</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import AutocompleteDish from '@/components/basic/input/AutocompleteDish.vue'
import moment from 'moment'
import { get } from 'lodash'

export default {
  components: {
    AutocompleteDish
  },
  props: {
    state: Boolean,
    dayProp: Number,
    menu: {
      type: String,
      default: () => 'menu1'
    }
  },
  data() {
    return {
      dialog: false,
      date: '',
      mainDishFilter: { type: 'main' },
      sideDishFilter: { type: 'side' },
      menu1MainDish1: null,
      // menu1MainDish2: null,
      menu1SideDishes: [],
      menu1SideDishNum: 1,
      menu2MainDish1: null,
      // menu2MainDish2: null,
      menu2SideDishes: [],
      menu2SideDishNum: 1
    }
  },
  computed: {
    ...mapState('FoodMenu', ['menuListDisplay']),
    ...mapGetters('FoodMenu', ['startWeek']),

    menu1SideDishNumArray() {
      return [...Array(this.menu1SideDishNum).keys()]
    },
    menu2SideDishNumArray() {
      return [...Array(this.menu2SideDishNum).keys()]
    }
  },
  methods: {
    ...mapActions('FoodMenu', ['createMenu', 'fetchData', 'updateMenu']),
    addSideDishMenu1() {
      this.menu1SideDishNum++
    },
    removeSideDishMenu1(index) {
      this.menu1SideDishes.splice(index, 1)
      if (this.menu1SideDishNum > 1) this.menu1SideDishNum--
    },
    addSideDishMenu2() {
      this.menu2SideDishNum++
    },
    removeSideDishMenu2(index) {
      this.menu2SideDishes.splice(index, 1)
      if (this.menu2SideDishNum > 1) this.menu2SideDishNum--
    },

    getData() {
      const menus = this.menuListDisplay.filter(m => m.day === this.dayProp && m.expandInfo && m.type !== 'action')
      const date = moment(this.startWeek)
        .startOf('day')
        .add(this.dayProp - 1, 'day')
        .toISOString()
      this.date = date
      if (get(menus, 'length')) {
        const main = menus.find(m => m.type === 'main')
        if (get(main, 'menu1List.length')) {
          this.menu1MainDish1 = main.menu1List[0]
        } else {
          this.menu1MainDish1 = null
        }
        if (get(main, 'menu2List.length')) {
          this.menu2MainDish1 = main.menu2List[0]
        } else {
          this.menu2MainDish1 = null
        }

        const side = menus.find(m => m.type === 'side')
        if (get(main, 'menu1List.length')) {
          this.menu1SideDishNum = side.menu1List.length || 1
          this.menu2SideDishNum = side.menu2List.length || 1
          this.menu1SideDishes = side.menu1List
          this.menu2SideDishes = side.menu2List
        } else {
          this.menu1SideDishNum = 1
          this.menu2SideDishNum = 1
          this.menu1SideDishes = []
          this.menu2SideDishes = []
        }
      }
    },
    cancel() {
      this.dialog = false
    },
    async save() {
      if (!this.$refs.form.validate()) return
      this.$loading.active = true
      try {
        const menu1SideDishIds = this.menu1SideDishes.map(d => d.id)
        const menu2SideDishIds = this.menu2SideDishes.map(d => d.id)
        const dateMoment = moment(this.date)
        const data = {
          date: dateMoment.startOf('day').toISOString(),
          day: dateMoment.day().toString(),
          firstMainDishes: get(this.menu1MainDish1, 'id') ? [this.menu1MainDish1.id] : null,
          secondMainDishes: get(this.menu2MainDish1, 'id') ? [this.menu2MainDish1.id] : null,
          firstSideDishes: menu1SideDishIds,
          secondSideDishes: menu2SideDishIds
        }

        const menuRecord = this.menuListDisplay.find(m => +m.day === this.dayProp && m.commonInfor)
        if (get(menuRecord, 'id')) {
          await this.updateMenu({ id: menuRecord.id, ...data })
        } else {
          await this.createMenu(data)
        }
        await this.fetchData()

        this.dialog = false
        this.$alert.updateSuccess()
      } catch (error) {
        console.error(error)
        this.$alert.updateError(error)
      } finally {
        this.$loading.active = false
      }
    }
  },
  watch: {
    state(state) {
      this.getData()
      this.dialog = true
      this.$refs.form && this.$refs.form.resetValidation()
    }
  }
}
</script>
